import { Button, LearnMoreLink, Page } from '@ui/themed';
import { t } from 'i18next';
import { useState } from 'react';
import { useHandlers, withPageProviders } from '../../../../context/page-context';
import { TutorialChecklist, type TutorialChecklistProps } from '../components/tutorial-checklist';

export type TutorialExitReason = 'completed' | 'skipped';

type TutorialPageContentProps = TutorialChecklistProps;

export const TutorialPage = withPageProviders(
  ({ onCompletedChange, onAllComplete, ...checklistProps }: TutorialPageContentProps) => {
    const { navigationHandler } = useHandlers();
    const [isJustCompleted, setIsJustCompleted] = useState<boolean>(false);
    const [isCompleted, setIsCompleted] = useState<boolean>();

    return (
      <Page
        title={t('features:onboarding.pages.tutorial_page.title')}
        description={
          <>
            <span className="flex flex-row flex-nowrap gap-1">
              {t('features:onboarding.pages.tutorial_page.description')}
              <LearnMoreLink link="https://docs.sparklayer.io/getting-started" />
            </span>
            {isJustCompleted ||
              (isCompleted === false && t('features:onboarding.pages.tutorial_page.explore_hint'))}
          </>
        }
      >
        <TutorialChecklist
          {...checklistProps}
          onCompletedChange={(complete) => {
            setIsCompleted(complete);
            onCompletedChange?.(complete);
          }}
          onAllComplete={() => {
            setIsJustCompleted(true);
            onAllComplete?.();
          }}
        />
        {isJustCompleted && (
          <div className="flex justify-end">
            <Button
              variant="primary"
              icon="rocket"
              onClick={() => navigationHandler.navigateById('home')}
            >
              {t('features:onboarding.pages.tutorial_page.complete')}
            </Button>
          </div>
        )}
      </Page>
    );
  },
);
